export default {
    primaryLine: {
        stroke: "#003F5C",
    },
    secondaryLine: {
        stroke: "#6ef0da",
    },
    primaryBar: {
        stroke: "#003F5C",
        fill: "#003F5C",
    },
    secondaryBar: {
        stroke: "#6ef0da",
        fill: "#6ef0da",
    },
};
